import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';

import { assetsModel } from '@/entities/assets';

import { getAlbumMediaCounts } from '../../lib';

type AlbumMediaCountsLabelProps = {
  assetIDs: string[];
};

export const AlbumMediaCountsLabel: FC<AlbumMediaCountsLabelProps> = ({
  assetIDs,
}) => {
  const assets = useAppSelector(assetsModel.selectors.selectEntities);
  const { photoCount, videoCount } = getAlbumMediaCounts(assetIDs, assets);

  return (
    <>
      {(photoCount > 0 || videoCount === 0) && (
        <FormattedMessage
          id="patientProfile.timeline.photoCount"
          defaultMessage="{count, plural, one {# photo} other {# photos}}"
          values={{ count: photoCount }}
        />
      )}
      {photoCount > 0 && videoCount > 0 && ' · '}
      {videoCount > 0 && (
        <FormattedMessage
          id="patientProfile.timeline.videoCount"
          defaultMessage="{count, plural, one {# video} other {# videos}}"
          values={{ count: videoCount }}
        />
      )}
    </>
  );
};
